export default __webpack_public_path__ + "static/media/sa-1-2.4e157d77.png";